import { getRequest } from "../../utils/api";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { logout } from "../../utils/auth";
import Loader from "../../Component/Loader/Loader";

const AffiliateDashboard = () => {
    const [affiliateStats, setAffiliateStats] = useState<any>({});
    const [loading, setLoading] = useState(true);
    const [range, setRange] = useState("30d");

    const [showCalendar, setShowCalendar] = useState(false);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    const fetchAffiliateStats = async (
        selectedRange = "30d",
        startDate = "",
        endDate = ""
    ) => {
        setLoading(true);

        try {
            let url = `/affiliate/affiliate-dashboard-summary?range=${selectedRange}`;

            if (selectedRange === "custom") {
                url += `&from=${startDate}&to=${endDate}`;
            }

            const response = await getRequest(url);

            if (response.status === "success") {
                setAffiliateStats(response.stats);
            } else if (response.status === "session_expired") {
                logout();
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (range !== "custom") {
            fetchAffiliateStats(range);
        }
    }, [range]);

    const applyCustomDate = () => {
        if (!fromDate || !toDate) {
            toast.error("Please select both dates");
            return;
        }

        fetchAffiliateStats("custom", fromDate, toDate);
        setShowCalendar(false);
    };
    return (
        <div className="hk-pg-wrapper">
            {loading && (<Loader />)}
            <div className="hk-pg-body py-0">
                <div className="page-wrap">
                    <div className="page-content ps-0">
                        <div className="page-detail-wrap">
                            <div className="page-body">
                                <div data-simplebar className="nicescroll-bar">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <div className="card">
                                                    <div className="card-body p-4">
                                                        <div className="d-flex align-items-center justify-content-between mb-3">
                                                            <div>
                                                                <h4 className="mb-1">Affiliate Program</h4>
                                                                <p className="mb-0">Track Commissions, Referrals & Growth</p>
                                                            </div>
                                                            <div>
                                                                <div className="top-bar-right">
                                                                    <button
                                                                        className={`filter-btn ${range === "30d" ? "active" : ""}`}
                                                                        onClick={() => setRange("30d")}
                                                                    >
                                                                        30d
                                                                    </button>

                                                                    <button
                                                                        className={`filter-btn ${range === "90d" ? "active" : ""}`}
                                                                        onClick={() => setRange("90d")}
                                                                    >
                                                                        90d
                                                                    </button>

                                                                    <button
                                                                        className={`filter-btn ${range === "6m" ? "active" : ""}`}
                                                                        onClick={() => setRange("6m")}
                                                                    >
                                                                        6 M
                                                                    </button>

                                                                    <button
                                                                        className={`filter-btn ${range === "1y" ? "active" : ""}`}
                                                                        onClick={() => setRange("1y")}
                                                                    >
                                                                        1 Yr
                                                                    </button>

                                                                    <button
                                                                        className={`filter-btn ${range === "custom" ? "active" : ""}`}
                                                                        onClick={() => {
                                                                            setRange("custom");
                                                                            setShowCalendar(!showCalendar);
                                                                        }}
                                                                    >
                                                                        <i className="ri-calendar-line"></i> Custom Date
                                                                    </button>
                                                                </div>

                                                                {showCalendar && (
                                                                    <div className="custom-date-box mt-2 p-3 border rounded bg-white shadow">
                                                                        <div className="row g-2">
                                                                            <div className="col-md-5">
                                                                                <label>From</label>
                                                                                <input
                                                                                    type="date"
                                                                                    className="form-control"
                                                                                    value={fromDate}
                                                                                    onChange={(e) => setFromDate(e.target.value)}
                                                                                />
                                                                            </div>

                                                                            <div className="col-md-5">
                                                                                <label>To</label>
                                                                                <input
                                                                                    type="date"
                                                                                    className="form-control"
                                                                                    value={toDate}
                                                                                    onChange={(e) => setToDate(e.target.value)}
                                                                                />
                                                                            </div>

                                                                            <div className="col-md-2 d-flex align-items-end">
                                                                                <button
                                                                                    className="btn btn-primary w-100"
                                                                                    onClick={(e) => applyCustomDate()}
                                                                                >
                                                                                    Apply
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="row g-3">
                                                            <div className="col">
                                                                <div className="card bg-gold-light-5 mb-0">
                                                                    <div className="card-body">
                                                                        <div className="d-flex justify-content-between">
                                                                            <div>
                                                                                <p className="mb-1 text-muted">Total affiliates</p>
                                                                                <h6 className="h2">{affiliateStats?.totalAffiliates?.value ?? 0}</h6>
                                                                            </div>
                                                                            <div className="flex-shrink-0">
                                                                                <div className="avatar avatar-sm avatar-icon avatar-soft-white  avatar-smmm">
                                                                                    <span className="initial-wrap" style={{ color: '#d5ba7d' }}><i className="ri-store-3-fill"></i></span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="d-flex align-items-center gap-2 mt-1">
                                                                            <span className="badge badge-sr bg-green-light-5 text-success mb-0"><i className="ri-arrow-up-line align-middle"></i>{affiliateStats?.totalAffiliates?.growth ?? 0} % </span>
                                                                            <span className="fs-13 text-muted">vs. previous month</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col">
                                                                <div className="card bg-green-light-5 mb-0">
                                                                    <div className="card-body">
                                                                        <div className="d-flex justify-content-between">
                                                                            <div>
                                                                                <p className="mb-1 text-muted">Active affiliates</p>
                                                                                <h6 className="h2">{affiliateStats?.activeAffiliates?.value ?? 0}</h6>
                                                                            </div>
                                                                            <div className="flex-shrink-0">
                                                                                <div className="avatar avatar-sm avatar-icon avatar-soft-white avatar-smmm">
                                                                                    <span className="initial-wrap" style={{ color: '#179237' }}><i className="ri-store-3-fill"></i></span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="d-flex align-items-center gap-2 mt-1">
                                                                            <span className="badge badge-sr bg-success-light-5 text-success mb-0"><i className="ri-arrow-up-line align-middle"></i>{affiliateStats?.activeAffiliates?.growth ?? 0} % </span>
                                                                            <span className="fs-13 text-muted">vs. previous month</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col">
                                                                <div className="card bg-yellow-light-5 mb-0">
                                                                    <div className="card-body">
                                                                        <div className="d-flex justify-content-between">
                                                                            <div>
                                                                                <p className="mb-1 text-muted">Total commission</p>
                                                                                <h6 className="h2">{affiliateStats?.totalCommission?.value ?? 0}</h6>
                                                                            </div>
                                                                            <div className="flex-shrink-0">
                                                                                <div className="avatar avatar-sm avatar-icon avatar-soft-white avatar-smmm">
                                                                                    <span className="initial-wrap" style={{ color: '#ffd477' }}><i className="ri-store-3-fill"></i></span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="d-flex align-items-center gap-2 mt-1">
                                                                            <span className="badge badge-sr bg-green-light-5 text-success mb-0"><i className="ri-arrow-up-line align-middle"></i>{affiliateStats?.totalCommission?.growth ?? 0} % </span>
                                                                            <span className="fs-13 text-muted">vs. previous month</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col">
                                                                <div className="card bg-blue-light-5 mb-0">
                                                                    <div className="card-body">
                                                                        <div className="d-flex justify-content-between">
                                                                            <div>
                                                                                <p className="mb-1 text-muted">Pending payout</p>
                                                                                <h6 className="h2">{affiliateStats?.pendingPayout?.value ?? 0}</h6>
                                                                            </div>
                                                                            <div className="flex-shrink-0">
                                                                                <div className="avatar avatar-sm avatar-icon avatar-soft-white avatar-smmm">
                                                                                    <span className="initial-wrap" style={{ color: '#52b5f3' }}><i className="ri-store-3-fill"></i></span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="d-flex align-items-center gap-2 mt-1">
                                                                            <span className="badge badge-sr bg-green-light-5 text-success mb-0"><i className="ri-arrow-up-line align-middle"></i>{affiliateStats?.pendingPayout?.growth ?? 0} % </span>
                                                                            <span className="fs-13 text-muted">vs. previous month</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col">
                                                                <div className="card bg-pink-light-5 mb-0">
                                                                    <div className="card-body">
                                                                        <div className="d-flex justify-content-between">
                                                                            <div>
                                                                                <p className="mb-1 text-muted">Total Conversions</p>
                                                                                <h6 className="h2">{affiliateStats?.totalConversions?.value ?? 0}</h6>
                                                                            </div>
                                                                            <div className="flex-shrink-0">
                                                                                <div className="avatar avatar-sm avatar-icon avatar-soft-white avatar-smmm">
                                                                                    <span className="initial-wrap" style={{ color: '#f36493' }}><i className="ri-store-3-fill"></i></span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="d-flex align-items-center gap-2 mt-1">
                                                                            <span className="badge badge-sr bg-green-light-5 text-success mb-0"><i className="ri-arrow-up-line align-middle"></i>{affiliateStats?.totalConversions?.growth ?? 0} % </span>
                                                                            <span className="fs-13 text-muted">vs. previous month</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row g-3">
                                            <div className="col-lg-12">
                                                <div className="card">
                                                    <div className="card-body">
                                                        <div className="summary-bar">
                                                            <div className="sb-item">
                                                                <div className="sb-lbl">Avg commission</div>
                                                                <div className="sb-val">
                                                                    ₹{affiliateStats?.summary?.avgCommission || 0}
                                                                </div>
                                                            </div>

                                                            <div className="sb-divider"></div>

                                                            <div className="sb-item">
                                                                <div className="sb-lbl">Total clicks</div>
                                                                <div className="sb-val">
                                                                    {affiliateStats?.summary?.totalClicks || 0}
                                                                </div>
                                                            </div>

                                                            <div className="sb-divider"></div>

                                                            <div className="sb-item">
                                                                <div className="sb-lbl">Conv. rate</div>
                                                                <div className="sb-val">
                                                                    {affiliateStats?.summary?.conversionRate || 0}%
                                                                </div>
                                                            </div>

                                                            <div className="sb-divider"></div>

                                                            <div className="sb-item">
                                                                <div className="sb-lbl">Avg payout</div>
                                                                <div className="sb-val">
                                                                    ₹{affiliateStats?.summary?.avgPayout || 0}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row g-3 mb-3">
                                            <div className="col-lg-6">
                                                <div className="card h-100">
                                                    <div className="card-header">
                                                        <h6>Commission vs Payouts</h6>
                                                    </div>
                                                    <div className="card-body"></div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="card h-100">
                                                    <div className="card-header">
                                                        <h6>Affiliate Status</h6>
                                                    </div>
                                                    <div className="card-body"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row g-3">
                                            <div className="col-lg-8">
                                                <div className="card h-100">
                                                    <div className="card-header">
                                                        <h6>Top Affiliates</h6>
                                                    </div>
                                                    <div className="card-body"></div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="card h-100">
                                                    <div className="card-header">
                                                        <h6>Upcoming Payouts</h6>
                                                    </div>
                                                    <div className="card-body"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default AffiliateDashboard